import styled from 'styled-components';

const ContainerLoading = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { ContainerLoading };
